export default "__VITE_ASSET__CQlHXZV6__"